import { Tooltip as Primitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.ts';

export const TooltipProvider = Primitive.Provider;
export const Tooltip = Primitive.Root;
export const TooltipTrigger = Primitive.Trigger;

export function TooltipContent({
  className,
  sideOffset = 4,
  ...props
}: ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Portal>
      <Primitive.Content
        sideOffset={sideOffset}
        className={cn(
          'bg-foreground text-background animate-fade-in shadow-raised z-50 rounded-lg px-2.5 py-1.5 text-xs font-medium',
          className,
        )}
        {...props}
      />
    </Primitive.Portal>
  );
}
